import {
  _convertPropertyValuesToArray,
  AbstractEntity,
  logComputeFunction,
  ParamsByNames,
  PlethoraLib,
  PropertyValuesDictionary,
  Transaction,
  UiData,
} from "plethora-lib"
import { AbstractUiEntity } from "../UiClasses/AbstractUiEntity"
import { DataTypeShapeType, DataTypeDirection, DataTypeSize, DataTypeColor } from "./GeneratedDataTypes"

export interface ILocatablePropertiesValues {
  X: number
  Y: number
}

export abstract class GeneratedLocatable extends AbstractUiEntity {
  constructor(id: number, propertyValues: PropertyValuesDictionary, uiData: UiData) {
    super("Locatable", id, propertyValues, [], uiData)
  }

  public computeFunction(propertyName: string, functionParameters: ParamsByNames, uiData: UiData): number {
    let result: number
    switch (propertyName) {
      default:
        throw new Error("Error on computeFunction(), unknown computed property name " + propertyName)
    }
    if (typeof result !== "number") {
      throw new Error("Error on computeFunction(), result is not a number")
    }
    logComputeFunction(this.id, this.name, propertyName, functionParameters, uiData, result)
    return result
  }

  protected onPropertyUpdate(propertyName: string, newValue: any, oldValue: any, uiData: UiData): void {
    super.onPropertyUpdate(propertyName, newValue, oldValue, uiData)
    switch (propertyName) {
      case "X": {
        this.onXUpdate(newValue, oldValue, uiData)
        return
      }

      case "Y": {
        this.onYUpdate(newValue, oldValue, uiData)
        return
      }

      default:
        throw new Error("Unkown property " + propertyName)
    }
  }

  public getX(): number {
    return this.getPropertyValue("X") as number
  }

  public setX(value: number, uiData: UiData = null): void {
    this.setPropertyValue("X", value, uiData, true, null)
  }
  public transactionSetX(transaction: Transaction, value: number, uiData: UiData = null): void {
    this.setPropertyValue("X", value, uiData, true, transaction)
  }

  protected abstract onXUpdate(newValue: number, oldValue: number, uiData: UiData): void

  public getY(): number {
    return this.getPropertyValue("Y") as number
  }

  public setY(value: number, uiData: UiData = null): void {
    this.setPropertyValue("Y", value, uiData, true, null)
  }
  public transactionSetY(transaction: Transaction, value: number, uiData: UiData = null): void {
    this.setPropertyValue("Y", value, uiData, true, transaction)
  }

  protected abstract onYUpdate(newValue: number, oldValue: number, uiData: UiData): void

  protected onAction(actionName: string, actionParameters: ParamsByNames, uiData: UiData): void {
    super.onAction(actionName, actionParameters, uiData)
    switch (actionName) {
      default:
        throw new Error("Unkown action " + actionName)
    }
  }

  protected onInteraction(
    interactionName: string,
    reactorEntity: AbstractEntity,
    interactionParameters: ParamsByNames,
    uiData: UiData
  ): void {
    super.onInteraction(interactionName, reactorEntity, interactionParameters, uiData)
    switch (interactionName) {
      default:
        throw new Error("Unkown interaction " + interactionName)
    }
  }

  public static createRequest(
    propertyValues: Partial<ILocatablePropertiesValues>,
    quantity: number,
    uiData: UiData = null
  ): void {
    PlethoraLib.getInstance()
      .getMessagesManager()
      .sendCreateRequestMessage(
        {
          entityName: "Locatable",
          properties: _convertPropertyValuesToArray(propertyValues),
          quantity,
        },
        uiData
      )
  }
}
